import React from 'react';
import { ExpandableContent } from '@ax2/common/components/ExpandableContent';
import styles from '@/styles/components/expandable/ExpandableQuestionsFlow.module.css';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import QuestionFlow from '@ax2/takesurvey/components/question-flow/QuestionFlow';
import ScreenerQuestionSchema from '@ax2/common/model/schemas/ScreenerQuestionSchema';
import { scroller, Events } from 'react-scroll';

export interface ExpandableQuestionsFlowData {
  id: string;
  containerId?: string;
  title?: string;
  subtitle?: string;
  expandLabel?: string;
  previewContent: JSX.Element;
  actionElement: JSX.Element;
  screeners: ScreenerQuestionSchema[];
  questions: QuestionSchema[];
}

export const ExpandableQuestionsFlow: React.FC<
  ExpandableQuestionsFlowData
> = props => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  return (
    <div className={styles.expandableQuestionFlow} id={props.id}>
      <ExpandableContent
        title={props.title}
        subtitle={props.subtitle}
        expandLabel={props.expandLabel ? props.expandLabel : 'Edit'}
        reduceLabel="Close Preview"
        actions={[props.actionElement]}
        previewContent={props.previewContent}
        expandedContent={
          <>
            {
              props.previewContent /*TODO: rewrite expandable content to shouw preview as first element*/
            }
            <div className={styles.questionFlowWrapper}>
              <QuestionFlow
                screeners={props.screeners}
                questions={props.questions}
                finalStep={{
                  name: 'SEND',
                }}
                isFastPreview={true}
                hasSkip={false}
              />
            </div>
          </>
        }
        isExpanded={isExpanded}
        onExpand={async isExpanded => {
          return new Promise(resolve => {
            Events.scrollEvent.register('end', to => {
              if (to === props.id) {
                Events.scrollEvent.remove('end');
                resolve();
              }
            });
            scroller.scrollTo(props.id, {
              duration: 400,
              delay: 0,
              smooth: 'easeInOutQuart',
              containerId: props.containerId,
            });
          }).then(() => setIsExpanded(isExpanded));
        }}
      />
    </div>
  );
};
